import Bacon from 'baconjs';

import {sanitizeSortForView} from './sanitize-sort-for-view';
import {toggleSort} from './toggle-sort';

/**
 * Called when the URL changes, or a saved filter is loaded. Ensures the
 * loaded query does not include a sort that isn't relevant to the current
 * view.
 *
 * @param  {Object} newQuery       - Full query object from URL
 * @return {string}                - Adjusted sort field
 */
function sanitizeSortForQuery(newQuery, topLevelEntity) {
    if (!newQuery) return [];

    return sanitizeSortForView(newQuery.sort, newQuery.view, topLevelEntity);
}

export default function (dispatcher, topLevelEntity) {
    const {push, stream} = dispatcher;
    const urlStream = stream('URL').map('.query');
    const selected = Bacon.update(
        'name',
        [urlStream.merge(stream('QUERY-RESET-TO-DEFAULT'))],
        (unused, query) => sanitizeSortForQuery(query, topLevelEntity),
        [stream('QUERY-LOAD-SAVED')],
        (unused, newQuery) => sanitizeSortForQuery(newQuery, topLevelEntity),
        [stream('VIEW-UPDATE')],
        (sort, view) => sanitizeSortForView(sort, view, topLevelEntity),
        [stream('SORT-TOGGLE')],
        toggleSort,
        [stream('SORT-CLEAR')],
        () => undefined
    );

    const field = Bacon.update('name', [selected.changes()], (unused, selectedSort) =>
        selectedSort ? selectedSort.replace('-', '') : undefined
    );

    const direction = Bacon.update('ascending', [selected.changes()], (unused, selectedSort) =>
        selectedSort && selectedSort.charAt(0) === '-' ? 'descending' : 'ascending'
    );

    return Bacon.combineTemplate({
        selected,
        field,
        direction,

        toggleSort(toggledField) {
            push('SORT-TOGGLE', toggledField);
        },
        clearSort() {
            push('SORT-CLEAR');
        },
    });
}
